'use client';

import { useQuery } from '@tanstack/react-query';
import { Subscription } from '@/app/types/Subscription';
import { getUserSubscription } from '@/services/user';

export const userSubscriptionQueryKey = ['user-subscription'] as const;

export function useUserSubscription(enabled = true) {
  return useQuery<Subscription>({
    queryKey: userSubscriptionQueryKey,
    queryFn: getUserSubscription,
    enabled,
    staleTime: 60_000,
    gcTime: 10 * 60_000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
